/*
* 当前系统时间操作
*/

var dateHelper = {
    //获取选择天数
    getDayList(monthStr) {
        var year = monthStr.split('-')[0];
        var month = parseInt(monthStr.split('-')[1]);
        var allCount = 0;

        var isType1 = false;
        var type1 = [1, 3, 5, 7, 8, 10, 12];
        for (var i = 0; i < type1.length; i++) {
            var item = type1[i];
            if (item == month) {
                isType1 = true;
                break;
            }
        }

        if (isType1) {
            allCount = 31;
        } else {
            if (month == 2) {
                if (this.isRunNian(month)) {
                    allCount = 29;
                } else {
                    allCount = 28;
                }
            } else {
                allCount = 30;
            }
        }

        var list=[];
        for(var j=0;j<allCount;j++){
            list.push(j+1);
        }
        return list;
    },
    isRunNian(year) {
        if (year % 4 == 0 && year % 100 != 0 || year % 400 == 0) {
            return true;
        } else {
            return false;
        }
    },
    //获取年份列表（2017 ~ 当前年+5）
    getYearList(){
        var start = 2017;
        var end = new Date().getFullYear() + 5;
        var list = [];
        for (var i = 0; i <= (end - start); i++) {
            list.push(start + i);
        }
        return list;
    },
    //获取年份列表
    getMonthList(){
        var start = 2017;
        var end = new Date().getFullYear() + 5;
        var list=[];
        for(var i=0;i<(end-start);i++){
            var number=start+i;

            list.push({
                label:number,
                value:number,
                children:[{
                    label:'1',
                    value:'1'
                },
                {
                    label:'4',
                    value:'4'
                },
                {
                    label:'7',
                    value:'7'
                },
                {
                    label:'10',
                    value:'10'
                }]
            });
        }
        return list;
    },
    // 研究生期数专用：年份从 2017 年开始
    getMonthListGraduate(){
        var start = 2017;
        var end = new Date().getFullYear() + 5;
        var list = [];
        for (var i = start; i <= end; i++) {
            list.push({
                label: i,
                value: i,
                children: [{
                    label: '1',
                    value: '1'
                },
                {
                    label: '4',
                    value: '4'
                },
                {
                    label: '7',
                    value: '7'
                },
                {
                    label: '10',
                    value: '10'
                }]
            });
        }
        return list;
    }
}

export default dateHelper;